import { render } from "./report-user-permissions.vue?vue&type=template&id=72179c49&ts=true"
import script from "./report-user-permissions.vue?vue&type=script&lang=ts"
export * from "./report-user-permissions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__